import { useSignOut } from 'korint-sdk/react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { legacyPermissionsControllerAtMeQueryOptions } from 'korint-sdk';
import { mutate } from 'swr';
import { AuthRequired } from '../auth-required';
import { Button } from '../../../ui/button';
import { AuthLayout } from '../auth-layout';
import { clearMfaSetupSkip } from '../mfaSetupSkip';
import { useAuthRedirect } from '../useAuthRedirect';

// Disgusting way to clear the cache. https://swr.vercel.app/docs/mutation.en-US#mutate-multiple-items
function clearCache() {
  return mutate(() => true, undefined, { revalidate: false });
}

export const MeView = ({ logo }: { logo: ReactNode }) => {
  const { data: user } = useQuery({
    ...legacyPermissionsControllerAtMeQueryOptions(),
  });
  const navigate = useNavigate();

  // Use shared hook for redirect handling
  const { redirectUrl } = useAuthRedirect();

  const queryClient = useQueryClient();
  const { signOut } = useSignOut({
    onSuccess: () => {
      navigate('/auth/sign-in');
      clearCache();
      queryClient.clear();
      clearMfaSetupSkip();
    },
  });

  return (
    <AuthRequired>
      <AuthLayout title="Vous êtes connecté" logo={logo}>
        Vous êtes connecté avec l&apos;adresse email suivante :
        <div className="font-medium">{user?.email}</div>
        <div className="grid grid-cols-2 gap-4 pt-8">
          <Button
            variant="outline"
            onClick={() => {
              signOut();
            }}
          >
            Se déconnecter
          </Button>
          <Button
            variant="secondary"
            onClick={async () => {
              navigate(redirectUrl);
            }}
          >
            Continuer
          </Button>
        </div>
      </AuthLayout>
    </AuthRequired>
  );
};
